import type { DummyFoods } from './dummyFoods'

export const noodles: DummyFoods = {
  Noodles: {
    Egg: {
      Cooked: ['Egg noodles (cooked)'],
      Dry: ['Egg noodles (dry)'],
    },
    Glass: {
      Cooked: ['Glass noodles (cooked)'],
      Dry: ['Glass noodles (dry)'],
    },
    Rice: {
      Cooked: ['Rice noodles (cooked)'],
      Dry: ['Rice noodles (dry)'],
    },
    Soba: {
      Cooked: ['Soba noodles (cooked)'],
      Dry: ['Soba noodles (dry)'],
    },
    Somen: {
      Cooked: ['Somen noodles (cooked)'],
      Dry: ['Somen noodles (dry)'],
    },
    Udon: {
      Cooked: ['Udon noodles (cooked)'],
      Dry: ['Udon noodles (dry)'],
    },
  },
}
